
import React from 'react';
import GenericTableEditor from '../../components/admin/GenericTableEditor';

const PoliciesEditor = () => {
  const columns = [
    { key: 'policy-en', label: 'Policy Name (EN)', type: 'text' },
    { key: 'policy-ms', label: 'Policy Name (MS)', type: 'text' },
    { key: 'description-en', label: 'Description (EN)', type: 'textarea' },
    { key: 'description-ms', label: 'Description (MS)', type: 'textarea' },
    { key: 'images_en', label: 'Images (EN) (Max 5)', type: 'image_list', hiddenInTable: true },
    { key: 'images_ms', label: 'Images (MS) (Max 5)', type: 'image_list', hiddenInTable: true },
  ];

  return <GenericTableEditor tableName="policies" columns={columns} title="Policies Manager" />;
};

export default PoliciesEditor;
